import { render, staticRenderFns } from "./NotentransferSV.vue?vue&type=template&id=5ad02406&"
import script from "./NotentransferSV.vue?vue&type=script&lang=js&"
export * from "./NotentransferSV.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports